// Desk build only: hide product categories that have nothing to order.
//
// Tapping a category filters the product list the app downloaded at start
// (services/local-store filterProducts: products whose category.odoo_id equals
// the category's odoo_id). A category without such a product only ever shows
// "No Data", so the panel leaves it out of the category bar.

// Category odoo ids that at least one product belongs to.
export const categoryIdsOf = (products) =>
  new Set((products || []).map((p) => p?.category?.odoo_id).filter((id) => id != null));

// Category ids from the saved product pages (each page: { count, results }),
// but only when the pages hold the whole product list: at least as many
// different products as the largest `count` the server reported. A list that
// is still being saved, or was cut short by a network drop, gives an empty
// set, so no category is hidden on partial information.
export const categoryIdsFromPages = (pages) => {
  const products = new Map();
  let expected = 0;
  (pages || []).forEach((page) => {
    if (!page || !Array.isArray(page.results)) return;
    if (typeof page.count === "number" && page.count > expected) expected = page.count;
    page.results.forEach((p) => { if (p && p.id != null) products.set(p.id, p); });
  });
  if (products.size === 0 || products.size < expected) return new Set();
  return categoryIdsOf([...products.values()]);
};

// Keeps the categories that have products. With no product ids known (the
// download has not finished, or failed) every category is kept, as today.
export const categoriesWithProducts = (categories, productCategoryIds) => {
  const list = categories || [];
  if (!productCategoryIds || productCategoryIds.size === 0) return list;
  return list.filter((c) => productCategoryIds.has(c?.odoo_id));
};
